import { millisecondsInMinute } from '@alltrails/data-formatting';

export const trailConditionsIntervalMin = 30;
export const trailConditionsIntervalMs = trailConditionsIntervalMin * millisecondsInMinute;
